import { MRT_TableInstance } from 'material-react-table'
import { DocumentRow } from '@/types/documents'
import { ProjectGridField } from '@/types/fields'
import BulkActionsSubheader from './BulkActionsSubheader'
import BulkEditValueMenuItem from './BulkEditValueMenuItem'
import BulkFieldResetMenuItem from './ClearFieldValuesMenuItem'
import useBulkActionCounts from './useBulkActionCounts'

type BulkEditMenuItemsProps = {
  table: MRT_TableInstance<Required<DocumentRow>>
  field: ProjectGridField
  closeMenu: () => void
}

export default function BulkEditMenuItems({
  table,
  field,
  closeMenu,
}: BulkEditMenuItemsProps) {
  const countValues = useBulkActionCounts({
    table,
    field,
  })
  const isCheckbox = field.project_grid_field_type.code === 'checkbox'
  return (
    <>
      <BulkActionsSubheader {...countValues} />
      <BulkEditValueMenuItem
        {...countValues}
        closeMenu={closeMenu}
        field={field}
      />
      {!isCheckbox && (
        <BulkFieldResetMenuItem
          {...countValues}
          closeMenu={closeMenu}
          field={field}
          variant="clear"
        />
      )}
      <BulkFieldResetMenuItem
        {...countValues}
        closeMenu={closeMenu}
        field={field}
        variant="removeManual"
      />
    </>
  )
}
